'use client'
import React, { useState, useEffect, Fragment } from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { Popover, Transition } from '@headlessui/react'
import { usePrivateContext } from 'utils/context'

const LeftMenu = () => {
  const { fedDetails } = usePrivateContext() || {}
  const pathname = usePathname()
  const [isActive, setIsActive] = useState([])
  const [items, setItems] = useState([])
  const [isExpanded, setIsExpanded] = useState(true)
  const [expandedItems, setExpandedItems] = useState({})

  const [activeSubItem, setActiveSubItem] = useState('')

  const checkIsActive = (items) => {
    return (
      items?.map((item) => {
        const isMainActive = item.link
          ? pathname.includes(item.link.split('/').filter(Boolean)[2])
          : false

        const isSubItemActive = item.subItems?.some((subItem) =>
          subItem.link
            ? pathname.includes(subItem.link.split('/').filter(Boolean)[2])
            : false
        )

        return isMainActive || isSubItemActive
      }) || []
    )
  }

  const handleLogOut = () => {
    localStorage.removeItem('fedId')
    localStorage.removeItem('fedToken')
  }

  useEffect(() => {
    setIsActive(checkIsActive(items))
  }, [items, pathname])

  const toggleItemExpansion = (itemId) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId]
    }))
  }

  useEffect(() => {
    setItems(
      [
        {
          id: 'personalInformation',
          icon: 'edit',
          name: 'Dades Personals',
          link: '/privat/federat/dades-personals'
        },
        {
          id: 'licenses',
          icon: 'license',
          name: 'Llicències',
          link: '/privat/federat/llicencies/renovar-llicencia'
        },
        {
          id: 'competition',
          icon: 'competition',
          name: 'Competició',
          link: '/privat/federat/competicio/els-teus-tornejos'
        },
        {
          id: 'ranking',
          icon: 'ranking',
          name: 'Rànquing',
          link: '/privat/federat/ranquing/ranquing-actual'
        },
        // {
        //   id: 'degrees',
        //   icon: 'degrees',
        //   name: 'Titulacions',
        //   link: '/privat/federat/titulacions'
        // },
        {
          id: 'formalities',
          icon: 'formalities',
          name: 'Tràmits',
          link: '/privat/federat/tramits/pagament-tornejos'
        },
        {
          id: 'moneder',
          icon: 'money-s',
          name: 'Moneder virtual',
          link: '/privat/federat/moneder-virtual'
        },
        (fedDetails?.PersonalInformation?.SupportsCaptain ||
          fedDetails?.PersonalInformation?.SupportsCaptainTournament) && {
          id: 'captain',
          icon: 'captain',
          name: 'Àrea Capità',
          link: '/privat/federat/area-capita/lligues/lliga',

          subItems: [
            ...(fedDetails?.PersonalInformation?.SupportsCaptain
              ? [
                  {
                    id: 'league',
                    icon: 'lligues',
                    name: 'Lliga',
                    link: '/privat/federat/area-capita/lligues/lliga'
                  }
                ]
              : []),
            ...(fedDetails?.PersonalInformation?.SupportsCaptainTournament
              ? [
                  {
                    id: 'tornejos',
                    icon: 'tornejos',
                    name: 'Tornejos',
                    link: '/privat/federat/area-capita/tornejos/quadres'
                  }
                ]
              : [])
          ]
        },
        {
          id: 'logout',
          icon: 'log-out',
          name: 'Log out',
          link: '/'
        }

        // {
        //   id: 'media',
        //   icon: 'media',
        //   name: 'Media',
        //   link: '/privat/federat/media'
        // }
      ].filter((i) => i)
    )
  }, [fedDetails])

  return (
    <>
      {/* MOBILE POPOVER */}
      <div className="absolute lg:hidden  z-20">
        <div className="bg-sec-grey-2 -ml-2 pl-4 py-7 pr-3 rounded-r-lg">
          <Popover>
            {({ open }) => {
              return (
                <>
                  <Popover.Button className="outline-none px-3 ml-2 ">
                    <img
                      src={`/assets/icons/arrow-simple-right.svg`}
                      alt="icon"
                    />
                  </Popover.Button>

                  <div className="absolute z-10 ">
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0 -translate-x-1"
                      enterTo="opacity-100 translate-x-0"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-x-0"
                      leaveTo="opacity-0 -translate-x-1"
                    >
                      <Popover.Panel className="transform">
                        <nav
                          className="w-[260px] -ml-3  -mt-[54px] h-screen bg-sec-grey-2 space-y-5 pt-3 rounded-r-lg pb-6 "
                          aria-label="Sidebar"
                        >
                          <div className="flex justify-end pr-6 pt-3 pb-3">
                            <Popover.Button className="outline-none">
                              <img src={`/assets/icons/cross.svg`} alt="icon" />
                            </Popover.Button>
                          </div>
                          {items.map((item, idx) => (
                            <div
                              key={item.id}
                              className="ml-1  pt-[0px] hover:bg-white hover:bg-opacity-25"
                            >
                              {item.subItems ? (
                                <button
                                  onClick={() => toggleItemExpansion(item.id)}
                                  className="font-alliance-medium text-blue text-[22px]    w-full "
                                >
                                  <div
                                    className={`flex pl-6 py-2 ${
                                      isActive[idx]
                                        ? 'bg-white bg-opacity-40'
                                        : ''
                                    }`}
                                  >
                                    <div
                                      className={
                                        isActive[idx] ? 'underline ' : ''
                                      }
                                    >
                                      {item.name}
                                    </div>
                                    <div
                                      className={`ml-auto mt-2   mr-4 transition-transform duration-300  `}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className={`lucide lucide-chevron-down ${
                                          expandedItems[item.id]
                                            ? 'rotate-180'
                                            : ''
                                        }`}
                                      >
                                        <path d="m6 9 6 6 6-6" />
                                      </svg>
                                    </div>
                                  </div>
                                </button>
                              ) : (
                                <Link
                                  scroll={false}
                                  href={item?.link ?? '#'}
                                  className={`font-alliance-medium text-blue text-[22px] hover:bg-white hover:bg-opacity-25  `}
                                  onClick={() =>
                                    item.id === 'logout' && handleLogOut()
                                  }
                                >
                                  <div
                                    className={`flex pl-6 py-2 ${
                                      isActive[idx]
                                        ? 'bg-white bg-opacity-40'
                                        : ''
                                    }`}
                                  >
                                    <div
                                      className={
                                        isActive[idx] ? 'underline' : ''
                                      }
                                    >
                                      {item.name}
                                    </div>
                                  </div>
                                </Link>
                              )}

                              {item.subItems && (
                                <div
                                  className={`space-y-2 overflow-hidden transition-all duration-300  ${
                                    expandedItems[item.id]
                                      ? 'max-h-96'
                                      : 'max-h-0'
                                  }`}
                                >
                                  {item.subItems.map((subItem) => (
                                    <Link
                                      scroll={false}
                                      key={subItem.id}
                                      href={subItem.link}
                                      className={`text-blue text-[18px] w-full flex  my-1 px-[34px] py-2 hover:bg-white hover:bg-opacity-25
              ${
                pathname === subItem.link
                  ? 'underline bg-white bg-opacity-40'
                  : ''
              }
              ${isExpanded ? '' : 'w-fit !ml-4 !px-2'}`}
                                    >
                                      <div
                                        className={`block ${
                                          isExpanded ? '' : 'lg:hidden'
                                        } whitespace-nowrap`}
                                      >
                                        {subItem.name}
                                      </div>
                                    </Link>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </nav>
                      </Popover.Panel>
                    </Transition>
                  </div>
                </>
              )
            }}
          </Popover>
        </div>
      </div>
      {/* mobile collapsed */}
      <nav
        className="block lg:hidden min-w-[68px] lg:mx-10 mt-24 mb-16 lg:mb-10 lg:mt-12 space-y-7 lg:space-y-2 transition-all duration-300 ease-in-out  gap-5 "
        aria-label="Sidebar"
      >
        {items.map((item, idx) => {
          return (
            <div key={item.id}>
              <Link
                scroll={false}
                href={`${item?.link ?? '#'}`}
                className="font-alliance-medium text-blue text-[22px] "
                onClick={() => {
                  if (item.id === 'logout') {
                    handleLogOut()
                  } else if (item.subItems) {
                    toggleItemExpansion(item.id)
                  } else {
                    const isActiveMod = items.map((_item) => item === _item)
                    setIsActive(isActiveMod)
                  }
                }}
              >
                <div
                  className={`flex items-center justify-center py-2 lg:px-8 lg:py-6 hover:bg-white hover:bg-opacity-25 w-full min-w-full ${
                    isActive[idx] ? 'bg-white bg-opacity-40' : ''
                  }`}
                >
                  {item?.icon ? (
                    <img
                      src={`/assets/icons/${item?.icon}.svg`}
                      alt="icon"
                      className=" max-w-[30px] "
                    />
                  ) : null}
                  <div
                    className={`hidden lg:block  ${
                      isActive[idx] ? 'lg:underline' : null
                    }`}
                  >
                    {item?.name}
                  </div>
                  {item.subItems && (
                    <div
                      className={`relative right-1 transition-transform duration-300 `}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className={`lucide lucide-chevron-down absolute -top-2 left-1                        ${
                          expandedItems[item.id] ? 'rotate-180' : ''
                        }`}
                      >
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </div>
                  )}
                </div>
              </Link>
              {item.subItems && (
                <div
                  className={`overflow-hidden transition-all duration-300   ${
                    expandedItems[item.id] ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  {item.subItems.map((subItem) => (
                    <Link
                      scroll={false}
                      key={subItem.id}
                      href={subItem.link}
                      className={`text-blue text-[18px] flex  my-1  hover:bg-white hover:bg-opacity-25  justify-center  py-2 ${
                        pathname === subItem.link
                          ? 'bg-white bg-opacity-40'
                          : ''
                      }

                ${isExpanded ? '' : ''}`}
                    >
                      {item?.icon ? (
                        <img
                          src={`/assets/icons/${subItem?.icon}.svg`}
                          alt="icon"
                          className={`max-w-[30px] ${isExpanded ? '' : ''}`}
                        />
                      ) : null}

                      <div
                        className={`hidden lg:block

                          ${isExpanded ? '' : 'lg:hidden'} whitespace-nowrap`}
                      >
                        {subItem.name}
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          )
        })}
      </nav>{' '}
      {/* desktop nav */}
      <nav
        className={`hidden lg:block ml-6 !m-0 h-full  lg:mx-10 mt-16 mb-16 lg:mb-10 lg:mt-3 space-y-10 lg:space-y-2 transition-all duration-300 ease-in-out gap-5 overflow-hidden   ${
          isExpanded ? 'lg:w-[360px]' : 'lg:w-20'
        }`}
        aria-label="Sidebar"
      >
        <button
          className="hidden lg:block ml-auto w-full p-2 bg--400 rounded-full lg:py-[25.4px] "
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <img
            className={`h-8 ml-auto px-6 transition-all duration-300 ease-in-out ${
              isExpanded ? 'bg--400 -rotate-180' : 'bg--300 rotate-0'
            }`}
            src={`/assets/icons/${
              isExpanded ? 'arrow-simple-right' : 'arrow-simple-right'
            }.svg`}
            alt="toggle menu"
          />
        </button>
        {items.map((item, idx) => (
          <div key={item.id}>
            {item.subItems ? (
              <button
                onClick={() => toggleItemExpansion(item.id)}
                className="w-full font-alliance-medium text-blue text-[22px] hover:bg-white hover:bg-opacity-25 "
              >
                <div
                  className={`flex items-center lg:px-8 lg:py-6  ${
                    isActive[idx] ? 'lg:bg-white lg:bg-opacity-40' : ''
                  } ${isExpanded ? '' : 'lg:py-[25.4px] !px-6'}`}
                >
                  {item?.icon && (
                    <img
                      src={`/assets/icons/${item.icon}.svg`}
                      alt="icon"
                      className={`mr-4 max-w-[30px] ${
                        !isExpanded && 'lg:mr-0'
                      }`}
                    />
                  )}
                  <div
                    className={`hidden lg:block ${!isExpanded && 'lg:hidden'} ${
                      isActive[idx] ? 'lg:underline' : ''
                    } whitespace-nowrap`}
                  >
                    {item.name}
                  </div>
                  <div
                    className={`ml-auto transition-transform duration-300 ${
                      expandedItems[item.id] ? 'rotate-180' : ''
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-chevron-down"
                    >
                      <path d="m6 9 6 6 6-6" />
                    </svg>
                  </div>
                </div>
              </button>
            ) : (
              <Link
                scroll={false}
                href={item?.link ?? '#'}
                className="font-alliance-medium text-blue text-[22px] "
                onClick={() => item.id === 'logout' && handleLogOut()}
              >
                <div
                  className={`flex items-center lg:px-8 lg:py-6 hover:bg-white hover:bg-opacity-25 ${
                    isActive[idx] ? 'lg:bg-white lg:bg-opacity-40' : ''
                  } ${isExpanded ? '' : 'lg:py-[25.4px] !px-6'}`}
                >
                  {item?.icon && (
                    <img
                      src={`/assets/icons/${item.icon}.svg`}
                      alt="icon"
                      className={`mr-4 max-w-[30px] ${
                        !isExpanded && 'lg:mr-0'
                      }`}
                    />
                  )}
                  <div
                    className={`hidden lg:block ${!isExpanded && 'lg:hidden'} ${
                      isActive[idx] ? 'lg:underline' : ''
                    } whitespace-nowrap`}
                  >
                    {item.name}
                  </div>
                </div>
              </Link>
            )}

            {item.subItems && (
              <div
                className={`space-y-2 overflow-hidden transition-all duration-300  ${
                  expandedItems[item.id] ? 'max-h-96 ' : 'max-h-0 '
                }`}
              >
                {item.subItems.map((subItem) => (
                  <Link
                    scroll={false}
                    key={subItem.id}
                    href={subItem.link}
                    className={`text-blue text-[18px] flex ml-6 my-1 px-[29px] py-2 hover:bg-white hover:bg-opacity-25 ${
                      pathname === subItem.link
                        ? 'lg:bg-white lg:bg-opacity-40'
                        : ''
                    } ${isExpanded ? '' : 'w-fit !ml-4 !px-2'}`}
                  >
                    {subItem?.icon && (
                      <img
                        src={`/assets/icons/${subItem.icon}.svg`}
                        alt="icon"
                        className={`mr-4 max-w-[30px] ${
                          !isExpanded && 'lg:mr-0'
                        }`}
                      />
                    )}
                    <div
                      className={`hidden lg:block ${
                        !isExpanded && 'lg:hidden'
                      } whitespace-nowrap`}
                    >
                      {subItem.name}
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>
    </>
  )
}

export default LeftMenu
